<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-gold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M28.605 6a2 2 0 011.922 1.447l3.739 13A2 2 0 0132.344 23H15.656a2 2 0 01-1.922-2.553l3.739-13A2 2 0 0119.395 6h9.21zm-9.078 20.447A2 2 0 0017.605 25h-9.21a2 2 0 00-1.922 1.447l-3.739 13A2 2 0 004.656 42h16.688a1.999 1.999 0 001.922-2.553l-3.739-13zm23 0A2 2 0 0040.605 25h-9.21a2 2 0 00-1.922 1.447l-3.739 13A2 2 0 0027.656 42h16.688a1.999 1.999 0 001.922-2.553l-3.739-13zM9.901 29l-2.589 9h11.376l-2.589-9H9.901zm20.412 9l2.588-9h6.198l2.589 9H30.312zm-12-19l2.588-9h6.198l2.589 9H18.313z"/></svg>
</template>
<script>

export default {
  name: 'IconGold',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
